import map from 'lodash/map';
import assign from 'lodash/assign';

function doesDictionaryTermMatch(term, value) {
  if (term.isCaseSensitive) {
    if (value.indexOf(term.term) >= 0) {
      return term.priority;
    }
    return -1;
  }
  if (value.toUpperCase().indexOf(term.term.toUpperCase()) >= 0) {
    return term.priority;
  }

  return -1;
}

export default function loadDictionaryTermsSuccess(state, action) {
  const { groups } = state;
  const newGroups = map(
    groups,
    (group) => (
      action.data.reduce((memo, term) => {
        const { name: groupName } = group;
        const priority = doesDictionaryTermMatch(term, groupName);

        if (
          priority >= 0
          && (!memo.hasDictionaryTerm || memo.dictionaryTerm.priority < priority)
        ) {
          return assign(memo, {
            hasDictionaryTerm: true,
            dictionaryTerm: term,
          });
        }
        return memo;
      }, assign({}, group, { hasDictionaryTerm: false }))),
  );
  return {
    ...state,
    groups: newGroups,
  };
}